/** 搜索START */
const SEARCH_HISTORY = 'searchHistory'
/** 搜索END */

/** 用户START */
const TOKEN = 'token'
const USERINFO = 'userInfo'
const REFRESH_TOKEN = 'refresh_token'
const ROLES = 'roles'
const PERMISSIONS = 'permissions'
const TENANTCODE = 'tenantCode'
const SYS_CONFIG = 'sys_config'
/** 用户END */

/** 考试START */
const EXAM = 'exam'
const EXAM_RECORD = 'examRecord'
const SUBJECT = 'subject'
const INCORRECT_RECORD = 'incorrectRecord'
const CARDS = 'cards'
/** 考试END */

/** 练习START */
const PRACTICE = 'practice'
const PRACTICE_RECORD = 'practiceRecord'
const PRACTICE_SUBJECT = 'practiceSubject'
/** 练习END */

export {
  SEARCH_HISTORY,
  TOKEN,
  USERINFO,
  ROLES,
  REFRESH_TOKEN,
  PERMISSIONS,
  TENANTCODE,
  SYS_CONFIG,
  EXAM,
  EXAM_RECORD,
  SUBJECT,
  INCORRECT_RECORD,
  CARDS,
  PRACTICE,
  PRACTICE_RECORD,
  PRACTICE_SUBJECT
}



// WEBPACK FOOTER //
// ./src/utils/storeMap.js